import { RotatingLines } from 'react-loader-spinner';

export interface ToggleProps {
    active: boolean;
    loading?: boolean;
    onChange?: (active: boolean) => void;
    label?: string;
    disabled?: boolean;
}

const Toggle = ({
    active,
    loading = false,
    onChange,
    label,
    disabled = false,
}: ToggleProps) => {
    const isDisabled = disabled || loading;

    return (
        <button
            type="button"
            role="switch"
            aria-checked={active}
            aria-label={label ?? (active ? 'Active' : 'Inactive')}
            disabled={isDisabled}
            onClick={() => !isDisabled && onChange?.(!active)}
            className={`relative inline-flex items-center min-w-9 min-h-5 rounded-full transition-colors
                ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}
                ${active ? 'bg-[var(--primary-color)]' : 'bg-[var(--secondary-surface-color)]'}
            `}
        >
            {/* Knob */}
            <span
                className={`absolute flex items-center justify-center w-4 h-4 rounded-full bg-white shadow transition-all duration-200
                    ${
                        loading
                            ? 'translate-x-[9px]'   // CENTER
                            : active
                            ? 'translate-x-[18px]' // RIGHT
                            : 'translate-x-[2px]'  // LEFT
                    }
                `}
            >
                {loading && (
                    <RotatingLines
                        width="12"
                        strokeColor="#000"
                        strokeWidth="3"
                        animationDuration="0.75"
                    />
                )}
            </span>
        </button>
    );
};

export default Toggle;